import React from 'react';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SEO from '../components/SEO';
import TrustBar from '../components/TrustBar';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://lsabill.net/#organization',
      name: 'LSABill',
      url: 'https://lsabill.net/',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://lsabill.net/#website',
      url: 'https://lsabill.net/',
      name: 'LSABill',
      publisher: {
        '@id': 'https://lsabill.net/#organization',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://lsabill.net/#webpage',
      url: 'https://lsabill.net/index.html',
      name: 'LSABill',
      description:
        'Online customer care portal for managing and cancelling subscriptions from LSABill partner sites.',
      isPartOf: {
        '@id': 'https://lsabill.net/#website',
      },
      about: {
        '@id': 'https://lsabill.net/#cancellation-service',
      },
    },
    {
      '@type': 'Service',
      '@id': 'https://lsabill.net/#cancellation-service',
      name: 'LSABill Subscription Cancellation Service',
      description:
        'Online service for managing and cancelling subscriptions from LSABill partner sites.',
      url: 'https://lsabill.net/',
      provider: {
        '@id': 'https://lsabill.net/#organization',
      },
    },
  ],
};

export default function HomePage() {
  const title = 'Subscription Support & Cancellation Service Online';
  const description =
    'Manage subscriptions, request cancellations, resolve billing issues, and contact support agents anytime with fast, secure, and reliable assistance.';
  const url = 'https://lsabill.net/';

  return (
    <div className="page-shell min-h-screen">
      <SEO
        title={title}
        description={description}
        canonicalUrl={url}
        ogTitle={title}
        ogDescription={description}
        ogUrl={url}
        ogImage="https://lsabill.net/logo192.png"
        schema={homeSchema}
      />
      <Header />
      <main className="pb-6">
        <Hero />
        <TrustBar className="pt-0" />
        <Features className="pt-0" />
      </main>
      <Footer />
    </div>
  );
}
